/**
 * Determines whether a driver's profile is fully complete so the invite
 * flow can decide whether to land on home or the signup wizard.
 *
 * The backend's toPublicDriver() shape does NOT return raw DL/Aadhaar/PAN
 * strings — it returns boolean presence flags (hasDl, hasAadhaar, hasPan)
 * to avoid shipping sensitive numbers over the wire. We mirror that contract
 * here so this predicate works directly on the DriverProfile the auth store
 * and the redeem-code response both use.
 */
export type ProfileLike = {
  name?: string | null;
  hasDl?: boolean;
  hasAadhaar?: boolean;
  hasPan?: boolean;
};

export function isProfileComplete(d: ProfileLike): boolean {
  return Boolean(
    d.name?.trim() &&
    d.hasDl &&
    d.hasAadhaar &&
    d.hasPan,
  );
}
